import React from 'react';
import styles from '../ADP/initiateForm/form.module.scss';
import CustomFields from '../../../components/customFields/CustomFields';
import Collapsible from '../../../components/collapsible/Collapsible';
import ReqAttachments from '../ADP/Components/ReqAttachments';

export const staticFields = [
  {
    conditional: false,
    default: false,
    description: '',
    enable_ocr: false,
    full_width: false,
    id: 'attachments',
    internal: true,
    list_view: false,
    lock: false,
    required: true,
    search_enable: false,
    source_fields: [],
    system_generated: false,
    title: 'Attachments',
    type: 'attachments'
  },
  {
    conditional: false,
    default: false,
    description: '',
    enable_ocr: false,
    full_width: false,
    id: 'photo',
    internal: true,
    list_view: false,
    lock: false,
    required: true,
    search_enable: false,
    source_fields: [],
    isCrop: true,
    system_generated: false,
    title: 'Profile Picture',
    type: 'attachments'
  },
  {
    conditional: false,
    default: false,
    description: '',
    enable_ocr: false,
    full_width: true,
    id: 'signature',
    isDisabled: false,
    internal: true,
    list_view: false,
    lock: false,
    required: true,
    search_enable: false,
    source_fields: [],
    system_generated: false,
    title: 'Signature',
    type: 'signature'
  }
];

export const adpDefaultIDs = [
  'first_name', 'last_name', 'email', 'phone', 'designation', 'dob', 'company',
  'lic_issue_date', 'lic_exp_date', 'permit_type', 'category_of_adp', 'signature',
  'driving_lic_num', 'type_of_lic', 'issusing_authority', 'employee_id'
];

export const getTitles = (data, fieldId) => {
  let fieldTitle = '';
  if (data?.length !== 0) {
    data.forEach((ele) => {
      if (ele.id === fieldId) {
        fieldTitle = ele.title;
      }
    });
  }
  return fieldTitle;
};

export const getRequired = (data, isFieldError, errors, answers) => {
  let requiredKeys = {
    signature: true, attachments: true
  };
  let FieldError = { ...errors };
  if (data?.length !== 0) {
    data.forEach((ele) => {
      // checking required fields
      if (ele.required) {
        // checking required default fields
        if (adpDefaultIDs.includes(ele.id)) {
          requiredKeys = { ...requiredKeys, [ele.id]: true };
          FieldError = { ...FieldError, [ele.id]: !answers[ele.id] };
          // checking required fields
        } else if (!(adpDefaultIDs.includes(ele.id))) {
          requiredKeys = { ...requiredKeys, [ele.id]: true };
          FieldError = { ...FieldError, [ele.id]: !answers.response?.[ele.id] };
        }
      }
    });
  }
  return isFieldError ? FieldError : requiredKeys;
};

const getRenewalRequired = (renewalFields) => {
  let requiredKeys = {};
  if (renewalFields?.length !== 0) {
    renewalFields.forEach((ele) => {
      // checking required fields
      if (ele.required) {
          requiredKeys = { ...requiredKeys, [ele.id]: true };
      }
    });
  }
  return requiredKeys;
};

export const valueType = (item) => {
  if (item?.type === 'boolean') {
    return { value: false };
  }
  if (item?.type === 'attachments' || item?.type === 'signature') {
    return { value: [] };
  }
  if (item?.id === 'tpaa' || item?.id === 'tpao') {
    return { value: 0 };
  }
  if (item?.id === 'vrea') {
    return { value: '' };
  }
  return { value: null };
};

export const getValue = (item, answers) => {
  const idExistsInDefault = adpDefaultIDs.includes(item.id);
  let answer;
  if (idExistsInDefault) {
    answer = answers[item?.id];
  } else if (item.type === 'attachments') {
    answer = answers.response?.[item?.id]?.length;
  } else {
    answer = answers.response?.[item?.id];
  }
  return !answer;
};

export const getDefAnswer = (item, answers) => {
  if (answers[item.id]) {
    return answers[item.id];
  }
  return valueType(item)?.value;
};

export const getCusAns = (item, answers) => {
  if (answers.response?.[item.id]) {
    return answers.response?.[item.id];
  }
  return valueType(item)?.value;
};

export const filterCustomFieldAnswers = (oldFields, newFields, answersData) => {
  const validFields = newFields?.reduce((acc, field) => {
    acc[field.id] = field;
    return acc;
  }, {});

  return Object.keys(answersData || {})?.reduce((filtered, fieldId) => {
    const oldField = oldFields.find(field => (field.id).toString() === fieldId.toString());
    const newField = validFields[fieldId];
    let filteredField = filtered;
    const answer = answersData[fieldId];

    if (oldField && newField
      && oldField.type === newField.type
      && oldField.title === newField.title) {
        // Additional type validation for answers
        const isValid = (
          (newField.type === 'boolean' && typeof answer === 'boolean')
          || ['select', 'string', 'number', 'date'].includes(newField.type) && typeof answer === 'string'
          || ['multiselect', 'attachments', 'signature'].includes(newField.type) && Array.isArray(answer) && answer.length > 0
        );
      if (isValid) {
        filteredField[fieldId] = answer;
      }
    }

    return filteredField;
  }, {});
};

export const getAttachmentIds = data => Object.entries(data || {}).reduce((acc, [key, value]) => {
  if (Array.isArray(value) && value.length > 0 && value[0]?.attachment_id) {
    acc[key] = value.map(v => v.attachment_id);
  } else {
    acc[key] = value;
  }
  return acc;
}, {});

export const renderFieldComponent = (
    state,
    notes,
    errors,
    reqAttach,
    allFields,
    fieldAnswers,
    handleAnswerChanged,
    handleRemoveAttachments,
    handleFieldErrorChanged,
    uploadtoS3,
    getLoadingStatus,
    entityName,
    renewalFields = [],
    renewalErrors,
    handleRenewalAnswerChanged,
    handleRenewalFieldErrorChanged,
    applicationType
  ) => (
  <>
    {/* All Default and Custom fields from Schema */}
    <div>
      <CustomFields
        handleAnswerChanged={(a, b) => (handleAnswerChanged(adpDefaultIDs.includes(b) ? 'answers': 'response', a, b))}
        handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
        handleAutoUploadAttachments={uploadtoS3}
        getLoadingStatus={getLoadingStatus}
        entityName={entityName}
        applicationType={applicationType}
        showFormErrors={state.formErrors}
        requiredMap={getRequired(allFields, true, errors, state?.answers)}
        fields={allFields}
        answers={fieldAnswers}
        adp
        isSignatureUpload
        forQuestionMarkHelp
      />
    </div>
    {/* Renewal fields */}
    {renewalFields.length > 0
     && <CustomFields
          handleAnswerChanged={(a, b) => (handleRenewalAnswerChanged(a, b))}
          handleFieldErrorChanged={(a, b) => handleRenewalFieldErrorChanged(a, b)}
          handleAutoUploadAttachments={uploadtoS3}
          getLoadingStatus={getLoadingStatus}
          entityName={entityName}
          applicationType={applicationType}
          showFormErrors={state.formErrors}
          requiredMap={getRenewalRequired(renewalFields)}
          fields={renewalFields}
          answers={state.answers?.renewal_response || {}}
          adp
          forQuestionMarkHelp
        />
    }
    {/* Notes */}
    <div>
      <Collapsible
        adp
        title="Note:"
        openOnMount={false}
        collapsibleHeight="0"
        styleClasses={styles.collapse}
      >
        {notes?.length !== 0 && (
          <div style={{ height: 'auto' }}>
            {notes?.map((ele, i) => (
              <p key={`${i + 1}`}>
                {`(${i + 1}) ${ele}`}
              </p>
            ))}
          </div>
        )}
      </Collapsible>
    </div>
    {/* Required Attachments */}
    {reqAttach?.length !== 0 && (
    <div>
      <Collapsible
        adp
        title="Required Attachments:"
        openOnMount={false}
        collapsibleHeight="0"
        overflowVisible
      >
        <div style={{ height: 'auto' }}>
          {reqAttach?.map((ele) => {
            const attachmentName = typeof ele === 'object' ? ele.attachmentName : ele;
            return (
              <ReqAttachments
                {...staticFields[0]}
                handleAnswerChanged={(a, b) => handleAnswerChanged(
                  'req_attachments', a, `${attachmentName}_${b}`
                )}
                attachments={state.answers?.req_attachments?.[`${typeof ele === 'object'
                  ? ele.attachmentName
                  : ele}_attachments`
                ]}
                showFieldErrors={state.formErrors}
                entityName={entityName}
                getLoadingStatus={getLoadingStatus}
                handleAutoUploadAttachments={uploadtoS3}
                handleRemove={handleRemoveAttachments}
                adpAttachments
                attachmentName={attachmentName}
                dateDetails={ele}
                adpAnswers={state.answers}
                handleDateChange={(a, b) => handleAnswerChanged(
                  'req_attachments_dates', a, `${attachmentName}_${b}`
                )}
                handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
              />
            );
          })}
        </div>
      </Collapsible>
    </div>
    )}
    {/* Static Default Fields - Attachments, Profile-Picture and Signature */}
    <div>
      <CustomFields
        fields={reqAttach?.length > 0
          ? staticFields.filter(field => field.id !== 'attachments')
          : staticFields}
        answers={state.answers}
        showFormErrors={state.formErrors}
        adpAttachments
        isSignatureUpload
        entityName={entityName}
        getLoadingStatus={getLoadingStatus}
        handleAutoUploadAttachments={uploadtoS3}
        handleRemove={handleRemoveAttachments}
        requiredMap={getRequired(staticFields, false, errors, state?.answers)}
        handleAnswerChanged={(a, b) => handleAnswerChanged('answers', a, b)}
        handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
        isCrop={staticFields?.filter(s => s.isCrop === true)}
        profilePic
        adp
        forQuestionMarkHelp
      />
    </div>
  </>
);

  export const validateFieldErrors = (currentAnswers, fields, defaultIDs, handleFieldErrorChanged, haveDimensions) => {
    const newErrors = {};

    // ---------- HELPER FUNCTIONS ----------

    // Get the value of a field
    const getValues = id => (defaultIDs.includes(id)
        ? currentAnswers[id]
        : currentAnswers.response?.[id]);

    // Check the conditional fields
    const isConditionMet = (field) => {
      if (!field.conditional) return true;

      const parentValue = getValues(field.conditional_field.key);

      if (parentValue == null) return false;

      // multiselect safe
      if (Array.isArray(parentValue)) {
        return field.conditional_values.some(cond => parentValue.includes(cond.value));
      }

      return field.conditional_values.some(
        cond => cond.value === parentValue
      );
    };

    // ---------- FOR DYNAMIC FIELDS ----------

    fields.forEach((field) => {
      const active = field.required && isConditionMet(field);

      if (!active) {
        newErrors[field.id] = false;
        return;
      }

      const value = getValues(field.id);
      newErrors[field.id] = isEmptyValue(value, field.type);
    });

    // ---------- FOR STATIC FIELDS ----------

    const { signature } = currentAnswers;
    const signValue = ((signature && typeof signature === 'object' && !Array.isArray(signature)) && signature.name)
      || (Array.isArray(signature) && signature.length > 0);

    newErrors.attachments = !currentAnswers.attachments.length;
    newErrors.signature = !signValue;

    if (!haveDimensions) {
      newErrors.length = !currentAnswers.length;
      newErrors.width = !currentAnswers.width;
      newErrors.height = !currentAnswers.height;
    }

    // ---------- SINGLE ERROR HANDLER ----------
    handleFieldErrorChanged(newErrors);

    return newErrors;
  };

  // carryForwardAttachments for ADP Renewal application
  export const carryForwardAttachments = async (oldData, newRequiredAttachments, renewalData) => {
    const updated = {
      req_attachments: {},
      req_attachments_details: { req_attachments_dates: {} },
      attachments: [],
      photo: []
    };

    const oldReqAttachments = oldData?.req_attachments || {};
    const oldDates = oldData?.req_attachments_details?.req_attachments_dates || {};

    // Comparing old schema with new schema and build correct attachment sections
    newRequiredAttachments.forEach((item) => {
      const name = item.attachmentName;
      const key = `${name}_attachments`;
      const dateKey = `${name}_date`;

      if (oldReqAttachments[key]) {
        updated.req_attachments[key] = [...oldReqAttachments[key]];
      } else {
        updated.req_attachments[key] = [];
      }
      if (item.showDateField) {
        updated.req_attachments_details.req_attachments_dates[dateKey] = oldDates[dateKey] || '';
      }
    });

    // All available req_attachments Flatten and add to attachments array
    updated.attachments = Object.values(updated.req_attachments).flat();

    // Profile Photo — No comparison, just copy old if exists
    updated.photo = oldData?.photo?.length > 0
        ? [renewalData?.photo?.[0]?.attachment_id]
        : [];

    // Add photo to attachments array
    if (updated.photo.length > 0) {
      updated.attachments.push(...updated.photo);
    }

    return updated;
  };

  // EMPTY VALUE CHECK

  export const isEmptyValue = (val, type) => {
    if (type === 'boolean') return val !== true;

    if (['attachments', 'multiselect'].includes(type)) {
      return !Array.isArray(val) || val.length === 0;
    }

    if (type === 'signature') {
      return (val === undefined
        || Array.isArray(val) && val.length === 0
        || (typeof val === 'object' && !Array.isArray(val)) && !val.name
      );
    }

    if (val == null) return true;

    if (typeof val === 'string') return val.trim() === '';

    if (Array.isArray(val)) return val.length === 0;

    if (type === 'number') return val === '';

    return false;
  };

  // CLEAR DEPENDENT ANSWERS
  export const getDependentClearMap = (
    parentId,
    conditionalFields,
    defaultIDs
  ) => {
    let result = { response: {} };

    const children = conditionalFields?.[parentId];
    if (!children) return result;

    children.forEach((child) => {
      const defaultValue = valueType(child)?.value;

      if (defaultIDs.includes(child.id)) {
        result[child.id] = defaultValue;
      } else {
        result.response[child.id] = defaultValue;
      }

      const deeper = getDependentClearMap(
        child.id,
        conditionalFields,
        defaultIDs
      );

      result = {
        ...result,
        ...deeper,
        response: {
          ...result.response,
          ...(deeper.response || {})
        }
      };
    });

    return result;
  };

  // handleAnswerChanged LOGIC
  export const getAnswerUpdates = ({
    section,
    answer,
    fieldId,
    allFields,
    conditionalFields,
    currentAnswers,
    defaultIDs
  }) => {
    const field = allFields?.find(f => f.id === fieldId);

    let updates = { response: {} };
    let errorUpdates = {};

    // ---------- 1. update current field ----------
    if (section === 'response') {
      updates.response[fieldId] = answer;
    } else if (section === 'req_attachments') {
      updates.req_attachments = {
        ...(currentAnswers.req_attachments || {}),
        [fieldId]: answer
      };
    } else if (section === 'req_attachments_dates') {
      updates.req_attachments_details = {
        ...(currentAnswers.req_attachments_details || {}),
        [section]: {
          ...(currentAnswers.req_attachments_details?.[section] || {}),
          [fieldId]: answer
        }
      };
    } else {
      updates[fieldId] = answer;
    }

    // ---------- 2. validate current ----------
    if (field) {
      errorUpdates[fieldId] = field.required
        ? isEmptyValue(answer, field.type)
        : false;
    }

    // ---------- 3. conditional logic ----------
    if (conditionalFields?.[fieldId]) {
      conditionalFields[fieldId].forEach((item) => {
        const conditionValues = item.conditional_values;

        const enable = conditionValues.some((val) => {
          if (field?.type === 'multiselect') {
            return answer?.includes(val.value);
          }
          return answer === val.value;
        });

        const defaultValue = valueType(item)?.value;

        // validation for child
        if (item.required) {
          const val = defaultIDs.includes(item.id)
            ? currentAnswers[item.id]
            : currentAnswers.response?.[item.id];

          errorUpdates[item.id] = enable
            ? isEmptyValue(val, item.type)
            : false;
        }

        if (enable) {
          // keep existing OR set default
          if (defaultIDs.includes(item.id)) {
            updates[item.id] = currentAnswers[item.id] ?? defaultValue;
          } else {
            updates.response[item.id] = currentAnswers.response?.[item.id] ?? defaultValue;
          }
        } else {
          // clear current child
          if (defaultIDs.includes(item.id)) {
            updates[item.id] = defaultValue;
          } else {
            updates.response[item.id] = defaultValue;
          }

          // clear all nested children recursively
          const cleared = getDependentClearMap(
            item.id,
            conditionalFields,
            defaultIDs
          );

          updates = {
            ...updates,
            ...cleared,
            response: {
              ...updates.response,
              ...(cleared.response || {})
            }
          };
        }
      });
    }

    return { updates, errorUpdates };
  };

  export const normalizeAttachments = (fields = [], response = {}) => fields
    .filter(f => f?.type === 'attachments')
    .reduce((acc, field) => {
      const value = response[field.id];
      if (Array.isArray(value) && value.length > 0) {
        acc[field.id] = value
          .map(item => item?.attachment_id)
          .filter(aid => typeof aid === 'string');
      }
      return acc;
    }, {});

  export const handleSignature = async (
    attachment,
    handleUploadAttachments,
    uploadtoS3,
    type
  ) => {
    let signatureValue = [];

    if (attachment) {
      signatureValue = Array.isArray(attachment) ? attachment : [attachment];
    }

    if (!signatureValue.length) return [];

    const isExisting = signatureValue[0]?.id;

    return isExisting
      ? handleUploadAttachments(signatureValue, type)
      : uploadtoS3(signatureValue);
  };

  export const customSort = (arr) => {
    const collator = new Intl.Collator(undefined, {
      numeric: true,
      sensitivity: 'case'
    });

    const group = (s) => {
      const trimmed = s.trim();

      if (/^[A-Za-z\s]+$/.test(trimmed)) return 1;
      if (/^[A-Za-z].*\d/.test(trimmed)) return 2;
      if (/^\d+.*[A-Za-z]/.test(trimmed)) return 3;
      if (/^\d+$/.test(trimmed)) return 4;

      return 5;
    };

    return arr.slice().sort((a, b) => {
      const gA = group(a);
      const gB = group(b);

      if (gA !== gB) return gA - gB;

      return collator.compare(a, b);
    });
  };
